<div class="wrap">
  <div [@translateToLeft]="selectedWeekId"
    (click)="shouldDisplayNextWeekButton && (selectedWeekId === 0 ? onNextWeek() : onPreviousWeek())" class="switcher">
    <div class="left">
      <div *ngIf="selectedWeekIdForAnimationView > 0" class="select select-previous">
        <app-svg-icon name="arrow-back" color="color-neutral-4"></app-svg-icon>
      </div>
      <div class="week-name">
        {{ switcherModel.items[selectedWeekId].i18nLabel | translate }}
      </div>
    </div>
    <div *ngIf="shouldDisplayNextWeekButton" class="right">
      <div *ngIf="selectedWeekIdForAnimationView < switcherModel.items.length - 1" class="select select-next">
        <app-svg-icon name="arrow-back" color="color-neutral-4"></app-svg-icon>
      </div>
    </div>
  </div>
</div>